<script setup lang="ts">
import { Button } from '@/components/ui/button';
import { setContentProtectionAction } from '@/actions/electron/SetContentProtectionAction.ts';
import { useSessionStore } from '@/stores/SessionStore.ts';
import { setTaskbarIconVisibilityAction } from '@/actions/electron/SetTaskbarIconVisibilityAction.ts';

const sessionStore = useSessionStore();

const setContentProtection = (enabled: boolean) => {
    setContentProtectionAction(enabled);
};

const setTaskbarIconVisibility = (visible: boolean) => {
    setTaskbarIconVisibilityAction(visible, true);
};
</script>

<template>
    <main class="flex-growp-4 flex-shrink p-4 pt-1">
        <section class="mb-8">
            <h2 class="mb-4 border-b pb-2">Content protection</h2>
            <Button
                v-if="sessionStore.isContentProtectionEnabled"
                variant="destructive"
                class="mb-4"
                @click="setContentProtection(false)"
            >
                Disable content protection
            </Button>
            <Button v-else variant="success" class="mb-4" @click="setContentProtection(true)">
                Enable content protection
            </Button>
            <p class="text-sm">
                Disabling content protection will make the Leetcode Wizard desktop application
                visible in all screenshots and to all screensharing software.
            </p>
        </section>

        <section>
            <h2 class="mb-4 border-b pb-2">Taskbar icon</h2>
            <Button
                v-if="sessionStore.isTaskbarIconVisible"
                variant="secondary"
                class="mb-4"
                @click="setTaskbarIconVisibility(false)"
            >
                Hide taskbar icon
            </Button>
            <Button v-else class="mb-4" @click="setTaskbarIconVisibility(true)">
                Show taskbar icon
            </Button>
            <p class="text-sm">
                If you are required to share your full screen during an interview we recommend
                hiding the taskbar icon.
            </p>
        </section>
    </main>
</template>
